var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInfillable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15080_236210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.625 2.92275C0.625 2.25559 0.858508 1.70519 1.3255 1.27156C1.7925 0.83791 2.39962 0.621094 3.14681 0.621094C3.88068 0.621094 4.47443 0.834567 4.92809 1.26155C5.39509 1.70187 5.6286 2.2756 5.6286 2.98279C5.6286 3.62325 5.40177 4.15695 4.94811 4.58394C4.48111 5.02426 3.86733 5.24442 3.10678 5.24442H3.08677C2.3529 5.24442 1.75916 5.02426 1.30549 4.58394C0.851823 4.14362 0.625 3.58989 0.625 2.92275ZM0.885187 20.4353V7.06572H5.32838V20.4353H0.885187ZM7.79015 20.4353H12.2333V12.97C12.2333 12.503 12.2867 12.1427 12.3935 11.8892C12.5803 11.4355 12.8638 11.0519 13.2441 10.7384C13.6243 10.4248 14.1013 10.268 14.6751 10.268C16.1695 10.268 16.9167 11.2754 16.9167 13.2902V20.4353H21.3599V12.7698C21.3599 10.7951 20.8929 9.29733 19.9589 8.27659C19.0249 7.25586 17.7907 6.74549 16.2562 6.74549C14.535 6.74549 13.194 7.48603 12.2333 8.96709V9.00712H12.2133L12.2333 8.96709V7.06572H7.79015C7.81683 7.49269 7.83018 8.8203 7.83018 11.0486C7.83018 13.2768 7.81683 16.4058 7.79015 20.4353Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15080_236210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7455,
    height: 20.7455,
    fill: "inherit",
    transform: "translate(0.625 0.146484)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInfillable);
export default __webpack_public_path__ + "static/media/linkedInfillable.fc9cf19c27cdf05f5f08042ab0396f65.svg";
export { ForwardRef as ReactComponent };